import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M1.898 3.417c-.629 0-1.139.51-1.139 1.14v9.508c0 .63.51 1.14 1.14 1.14h8.271c.63 0 1.14-.51 1.14-1.14V4.556c0-.629-.51-1.139-1.14-1.139H8.986v-.76h1.184c1.049 0 1.899.85 1.899 1.9v9.508c0 1.049-.85 1.899-1.899 1.899H1.898A1.9 1.9 0 0 1 0 14.065V4.556c0-1.048.85-1.898 1.898-1.898h1.088v.76z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M4.712 6.402a.38.38 0 0 1-.106.527L3.088 7.94l-.211-.316.21.316-.278.186-.718-.83a.38.38 0 0 1 .574-.497l.28.324 1.24-.827a.38.38 0 0 1 .527.105M5.79 7.12c0-.21.17-.38.379-.38h3.544a.38.38 0 0 1 0 .759H6.169a.38.38 0 0 1-.38-.38M4.712 9.187a.38.38 0 0 1-.106.526l-1.518 1.013-.211-.316.21.316-.278.185-.718-.83a.38.38 0 0 1 .574-.497l.28.324 1.24-.827a.38.38 0 0 1 .527.106M5.79 9.904c0-.21.17-.38.379-.38h3.544a.38.38 0 1 1 0 .76H6.169a.38.38 0 0 1-.38-.38M4.712 11.971a.38.38 0 0 1-.106.527L3.088 13.51l-.211-.316.21.316-.278.186-.718-.83a.38.38 0 1 1 .574-.497l.28.323 1.24-.826a.38.38 0 0 1 .527.105M5.79 12.688c0-.21.17-.38.379-.38h3.544a.38.38 0 0 1 0 .76H6.169a.38.38 0 0 1-.38-.38M5.445 2.025H3.673a.253.253 0 0 0-.253.253v1.266h5.488V2.278a.253.253 0 0 0-.253-.253H6.883V1.013A.253.253 0 0 0 6.63.759h-.932a.253.253 0 0 0-.253.253zm4.222 2.278H2.661V2.278c0-.56.453-1.012 1.012-1.012h1.013v-.254C4.686.453 5.139 0 5.698 0h.932c.559 0 1.012.453 1.012 1.013v.253h1.013c.559 0 1.012.453 1.012 1.012z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }